module.exports = __webpack_public_path__ + "img/ic_share.0f1942f5.svg";